import GCBadge from "@/app/(site)/_components/Molecules/GCBadge"
import SanityBadgeList from "@/app/(site)/_components/Molecules/GCBadge/SanityBadgeList"
import { type ResolvedBadge } from "@/src/utils/badges/types"

interface ProductBadgesProps {
    combinedBadges: string[]
    discountPercent: number
    resolvedSanityBadges?: ResolvedBadge[]
}

export const Badges = ({
    combinedBadges,
    discountPercent,
    resolvedSanityBadges
}: ProductBadgesProps) => {
    if (resolvedSanityBadges && resolvedSanityBadges.length > 0) {
        return (
            <SanityBadgeList
                badges={resolvedSanityBadges}
                className="flex flex-wrap gap-8"
            >
                {discountPercent > 0 && (
                    <GCBadge
                        badgeText={"-" + discountPercent.toString() + "%"}
                        badgeType="sale"
                    />
                )}
            </SanityBadgeList>
        )
    }

    if (!Array.isArray(combinedBadges) || combinedBadges.length === 0) return null
    return (
        <div className="flex flex-wrap gap-8">
            {combinedBadges.map(badge => {
                if (badge === "SALE" && discountPercent > 0) {
                    return (
                        <GCBadge
                            key={badge}
                            badgeText={"-" + discountPercent.toString() + "%"}
                            badgeType="sale"
                        />
                    )
                }
                if (badge !== "SALE") {
                    return (
                        <GCBadge
                            key={badge}
                            badgeText={badge}
                            textColor="white"
                            className="text-white"
                        />
                    )
                }
            })}
        </div>
    )
}
